import React, { useReducer, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container, Input } from "reactstrap";
import { initialize, defaultState } from "./../store/store";
import style from "./../Collateral.module.scss";
import { custodyReducer, validateForm } from "./../store/reducer";
import Footer from "./../Footer";
import { Numeric, Combobox, Field } from "./../../Order/Field/Field";
import Symbol from "./Symbol";
import { getIntStatusName } from "./../../../Collateral/types";
import { Mode } from "../../../../utils";
import { getEnabledStatus } from "./../utils";
import CircularProgress from "./../../../CircularProgress/CircularProgress";
import { showToast } from "../../../../utils/Helper";
const collateralWarranty = ({ open, toggle, addCollateralWarranty, services, role, toEdit, setToEdit, ...props }) => {
  const [state, dispatch] = useReducer(custodyReducer, defaultState(), initialize(props));
  const { fields, collateralWarrantyItem, ui } = state;
  const { errors, readonly } = fields;
  const onChange = (fields) => {
    dispatch({ type: "CHANGE_FIELDS_COLLATERAL_WARRANTY", fields });
    if (fields.CollateralAppraisal) {
      dispatch({
        type: "CHANGE_FIELDS_COLLATERAL_WARRANTY",
        fields: { CollateralMargin: 100 - fields.CollateralAppraisal },
      });
    }
    if (fields.CollateralMargin) {
      dispatch({
        type: "CHANGE_FIELDS_COLLATERAL_WARRANTY",
        fields: { CollateralAppraisal: 100 - fields.CollateralMargin },
      });
    }

    dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
  };

  if (collateralWarrantyItem.CollateralMargin == null) {
    dispatch({ type: "CHANGE_FIELDS_COLLATERAL_WARRANTY", fields: { CollateralMargin: 0 } });
  }

  if (collateralWarrantyItem.CollateralAppraisal == null) {
    dispatch({ type: "CHANGE_FIELDS_COLLATERAL_WARRANTY", fields: { CollateralAppraisal: 100 } });
  }

  const precheck = () => {
    state.fields.errors = {};
    dispatch({ type: "CHANGE_MODE", mode: Mode.PRECHECK });
    const hasErrors = validateForm(state);
    if (!hasErrors) {
      let order = {
        OrderQuantityIsCash: "false",
        OrderSide: "Sell",
        AssetId: state.collateralWarrantyItem.AssetId,
        CurrentAccount: {
          Quantity: state.collateralWarrantyItem.CollateralQuantity,
          AccountId: state.collateral.Accountid,
          Collateral: [
            {
              CollateralId: state.collateralWarrantyItem.CollateralId,
            },
          ],
        },
      };
      services.precheck(order).then((r) => {
        if (r.validation.result.Code == 200) {
          dispatch({ type: "CHANGE_MODE", mode: Mode.CONFIRM });
        } else {
          showToast("The volume exceed the quantity in the account", true);
          dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
        }
      });
    } else {
      dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
    }
  };

  const confirm = () => {
    dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: true } } });
    addCollateralWarranty(state.collateralWarrantyItem);
    toggle();
  };

  return (
    <div className={style.formContainer}>
      <div className={style.form}>
        {!ui.loading && (
          <Container>
            <Row>
              {toEdit ? (
                <Col xs={8} lg={4}>
                  <Field label={"Asset"}>
                    <Input
                      type="text"
                      readOnly={true}
                      value={collateralWarrantyItem.AssetTicker}
                    />
                  </Field>
                </Col>
              ) 
              : 
              (
                <Col xs={8} lg={4}>
                  <Symbol
                    isCurrency={false}
                    onChange={(v) =>
                      onChange({
                        AssetId: v.AssetId,
                        AssetTicker: v.AssetTicker,
                      })
                    }
                    error={errors.AssetTicker}
                    value={collateralWarrantyItem.AssetTicker}
                    fetchSearchSymbol={services.fetchSearchSymbol}
                  />
                </Col>
              )}
              <Col xs={8} lg={4}>
                <Field label={"Quantity"}>
                  <Numeric
                    value={collateralWarrantyItem.CollateralQuantity}
                    onChange={(v) => onChange({ CollateralQuantity: v })}
                    invalid={!!errors.CollateralQuantity}
                    dataTypeDecimalName="quantity"
                  />
                </Field>
              </Col>
              <Col xs={8} lg={4}>
                <Field label={"Status"} error={errors.type}>
                  <Combobox
                    value={collateralWarrantyItem.CollateralStatus}
                    items={getEnabledStatus(collateralWarrantyItem).map((key, index) => ({
                      id: key,
                      description: getIntStatusName(key),
                    }))}
                    disabled={collateralWarrantyItem.ToEdit ? (false) : (true)}
                    invalid={!!errors.CollateralStatus}
                    onChange={(v) => onChange({ CollateralStatus: v })}
                    emptyLabel={"Status"}
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                  />
                </Field>
              </Col>
              <Col xs={8} lg={4}>
                <Field label={"Margin"}>
                  <Numeric
                    value={collateralWarrantyItem.CollateralMargin}
                    placeholder={"Margin"}
                    min={0}
                    max={100}
                    onChange={(v) => onChange({ CollateralMargin: v })}
                    invalid={!!errors.CollateralMargin}
                    dataTypeDecimalName="currency"
                  />
                </Field>
              </Col>
              <Col xs={8} lg={4}>
                <Field label={"Appraisal"}>
                  <Numeric
                    value={collateralWarrantyItem.CollateralAppraisal}
                    placeholder={"Appraisal"}
                    min={0}
                    max={100}
                    onChange={(v) => onChange({ CollateralAppraisal: v })}
                    invalid={!!errors.CollateralAppraisal}
                    dataTypeDecimalName="currency"
                  />
                </Field>
              </Col>
              <Col xs={8} lg={4}>
                <Field label={"Maturity"}>
                  <Input
                    type="date"
                    value={collateralWarrantyItem.CollateralMaturity}
                    placeholder={"Maturity"}
                    onChange={(v) => onChange({ CollateralMaturity: v.target.value })}
                    invalid={!!errors.CollateralMaturity}
                  />
                </Field>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      <Footer
        toggle={toggle}
        dispatch={dispatch}
        buttons={state.buttons}
        actions={{
          precheck,
          confirm,
        }}
      />
    </div>
  );
};

export function validation(collateral) {
  return {};
}

export default collateralWarranty;
